const EMAIL_CHANGE_FLOW_KEY = "medsynciq_email_change_flow";

export interface EmailChangeFlowState {
  /** The account's current verified email at the moment the OTP was requested —
   *  scopes the session so it can never be resumed against a different account. */
  accountEmail: string;
  /** The target/new email this OTP was actually sent to. */
  pendingEmail: string;
  /** Epoch ms when this OTP expires. */
  otpExpiresAt: number;
}

export function saveEmailChangeFlowState(state: EmailChangeFlowState) {
  sessionStorage.setItem(EMAIL_CHANGE_FLOW_KEY, JSON.stringify(state));
}

export function getEmailChangeFlowState(): EmailChangeFlowState | null {
  const raw = sessionStorage.getItem(EMAIL_CHANGE_FLOW_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as EmailChangeFlowState;
  } catch {
    return null;
  }
}

export function clearEmailChangeFlowState() {
  sessionStorage.removeItem(EMAIL_CHANGE_FLOW_KEY);
}

/**
 * Returns the still-valid remaining OTP window if there's a persisted session that
 * matches both this account and this exact target email, or null if there's nothing
 * to resume (no session, wrong account, different target, or already expired).
 */
export function getResumableEmailChangeSession(
  accountEmail: string,
  targetEmail: string,
): { remainingSeconds: number } | null {
  const stored = getEmailChangeFlowState();
  if (!stored) return null;
  if (stored.accountEmail.toLowerCase() !== accountEmail.toLowerCase()) return null;
  if (stored.pendingEmail.toLowerCase() !== targetEmail.toLowerCase()) return null;
  const remainingSeconds = Math.max(0, Math.ceil((stored.otpExpiresAt - Date.now()) / 1000));
  return remainingSeconds > 0 ? { remainingSeconds } : null;
}
